<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <h4 class="text-uppercase mb-0">User Insights</h4>
          <span v-if="false" style="padding-left: 1rem;cursor: pointer;" @click="this.downloadProfile()">
            <IconDownLoad :size="'1.4rem'" />
          </span>
        </div>
        <div>
          <Datepicker v-model="selectedDate"  dark  auto-apply format="dd MMM yyyy"
             :max-date="new Date()" />
        </div>
      </div>
    </div>

    <div v-if="user" class="row mt-3">
        <div class="col-12" style="width: 33%; padding-right: 0;">
            <UserDetailsCard :user="user" />
        </div>
        <div class="col-12" style="width: 67%;">
          <div class="row">
            <div>
              <div v-if="performance && performanceData">
                <UserPerformance title="Performance" :period="formatDate(selectedDate)" 
                   :data="performance" :performance-data="performanceData" />
              </div>
            </div>
          </div>
        </div>
    </div>

    <div id="psycology-performance" v-if="performance && !isCommanderLogin && displayProfileTypes" class="row">
      <div v-if="user" class="row mt-3" style="padding-right: 0rem;">
        <div class="col-12" style="width: 60%;padding-right: 0;">
          <UserWellnessChart v-if="wellnessData" :wellness-data="wellnessData" 
            :selected-date="selectedDate" :udid="udid"/>
          <div v-else class="no-stress-found-container">
            <div class="d-flex flex-column h-100 align-items-center justify-content-center p-3"
                style="min-height: 23.5rem;" >
                <h5>No Wellness Data found.</h5>
                <div class="text-lighter font-weight-bold">
                      Sync band data to see results
                </div>
            </div>
          </div> 
        </div>
        <div class="col-12" style="width: 40%;padding-right: 0rem;">
          <user-reports title="Based on DNA and Wellness data"
            header="Recommended Profiles" :udid="udid" />
        </div>
      </div>
    </div>
    <div v-else-if="(isCommanderLogin || !displayProfileTypes) && wellnessData" class="row" style="padding: 1rem 1rem 0px 1rem;">
      <UserWellnessChart v-if="wellnessData" :wellness-data="wellnessData" 
            :selected-date="selectedDate" :udid="udid"/>
    </div>

    <div class="row" style="padding: 1rem;padding-bottom: 0;">
      <UserStressChart v-if="stressData" :stress-data="stressData" 
            :selected-date="selectedDate" />
      <div v-else class="no-stress-found-container">
        <div class="d-flex flex-column h-100 align-items-center justify-content-center p-3"
            style="min-height: 23.5rem;" >
            <h5>No Stress Data found.</h5>
            <div class="text-lighter font-weight-bold">
                  Synd band data to see results
            </div>
        </div>
      </div> 
    </div>

    <div v-show="udid != ''" class="row mt-3">
      <div class="col-12" v-if="user">
        <user-strain
          title="Strain"
          :udid="udid"
          :selected-date="formatDate(selectedDate)"
          :user="user"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <user-recovery
          title="Recovery"
          :udid="udid"
          :selected-date="formatDate(selectedDate)"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <user-sleep :udid="udid" :selected-date="formatDate(selectedDate)" />
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "@/helpers/constants.js";
import Utils from "@/helpers/utils.js";
import IconDownLoad from "@/shared/Controls/Icons/IconDownLoad.vue";
import UserReports from "./components/UserReports.vue";
import UserStrain from "./components/UserStrain.vue";
import UserRecovery from "./components/UserRecovery.vue";
import UserSleep from "./components/UserSleep.vue";
import Datepicker from "@vuepic/vue-datepicker";
import {useRoute} from "vue-router";
import dayjs from "dayjs";
import img from "@/assets/img/persons/v3_0050708.jpg";
import UserDetailsCard from "./components/insights/UserDetailsCard.vue";
import UserPerformance from "./components/insights/UserPerformace.vue";
import UserStressChart from "./components/UserStressChart.vue";
import UserWellnessChart from "./components/insights/UserWellnessChart.vue"

export default {
  name: "UserPhysiologicalData",
  components: {
    Datepicker,
    UserReports,
    UserStrain,
    UserRecovery,
    UserSleep,
    UserDetailsCard,
    UserPerformance,
    UserStressChart,
    IconDownLoad,
    UserWellnessChart,
  },
  data() {
    const queryDate = useRoute().query.date;
    return {
      selectedDate: !queryDate ? dayjs() : queryDate,
      user: null,
      performance: null,
      udid: "",
      img,
      stressData: null,
      performanceData: null,
      wellnessData: null,
      isCommanderLogin: false,
      displayProfileTypes : Constants.DISPLAY_PROFILE_TYPES,
    };
  },
  watch: {
    selectedDate() {
      if (this.selectedDate instanceof Date) {
        this.getUserData();
      } else this.selectedDate = new Date();
    },
  },
  mounted() {
    let loggedInUser = this.$store.getters["auth/getLoggedInUser"]();
    if (loggedInUser.role && loggedInUser.role.role_id == Constants.ROLES.PLATOON_COMMANDER) {
      this.isCommanderLogin = true;
    }
    this.getUserData();
  },
  methods: {
    formatDateOfBirth(dt) {
      return dayjs(dt).format("DD MMM YYYY");
    },
    formatDate(dt) {
      return dayjs(dt).format(Constants.BUCKET_FORMAT);
    },
    getUserData() {
      // get udid from url
      const currentRoute = this.$router.currentRoute;
      const { udid } = currentRoute.value.params;
      if (udid) {
       this.getUserDataByDate(udid);
       this.getUserStressData(udid);
       this.getUserPerformanceData(udid);
       this.getUserWellnessData(udid);
      } else {
        // no udid, redirect user to error page
        this.$router.push({ name: "Error Error500" });
      }
    },
    getUserDataByDate(udid) {
        // user profile and performance for selected date
      this.$store.dispatch("data/userDataByDate", {
            udid: udid,
            dt: this.selectedDate,
        })
        .then((data) => {
            if (data?.data) {
              this.user = data.data;
              this.udid = udid;
              this.performance = this.user?.performance;

              if (!this.performance) {
                this.performance = {
                  bucket: this.formatDate(this.selectedDate),
                  previous_recovery_score: 0,
                  previous_sleep_score: 0,
                  previous_strain: 0,
                  recovery_score: 0,
                  sleep_score: 0,
                  strain: 0,
                };
              }
            }
          });
    },
    getUserStressData(udid) {
      this.$store.dispatch("data/userStressData", {
          udid: udid,
          sort: Constants.STRESS_SORT_COLUMN,
          order: Constants.SORT_ASC,
          dt_from: dayjs(this.selectedDate)
            .startOf("day")
            .subtract(1, "day")
            .format(Constants.BUCKET_FORMAT),
          dt_to: dayjs(this.selectedDate)
            .startOf("day")
            .format(Constants.BUCKET_FORMAT),
        })
        .then((response) => {
          let labels = [], data=[];
          if(response && response.data && response.data.length > 0) {
              for(let stress of response.data) {
                labels.push(dayjs(stress.stress_timestamp).format(Constants.TIME_FORMAT));
                data.push(stress.score);
              }
          }

          if(data.length > 0) {
            this.stressData = {
              minStress: Math.min.apply(Math, data),
              maxStress: Math.max.apply(Math, data),
              latestStress: data[0],
              averageStress: Math.round(data.reduce((a, b) => a + b) / data.length),
              labels: labels,
              scores: data
            };
          } else {
            this.stressData = null;
          }
        });
    },
    getUserPerformanceData(udid) {
      this.$store.dispatch("data/userPerformanceData", {
          udid: udid,
          sort: Constants.STRESS_SORT_COLUMN,
          order: Constants.SORT_ASC,
          dt_from: dayjs(this.selectedDate)
            .startOf("day")
            .format(Constants.BUCKET_FORMAT),
          dt_to: dayjs(this.selectedDate)
            .startOf("day")
            .add(1, "day")
            .format(Constants.BUCKET_FORMAT),
        })
        .then((response) => {
          this.performanceData = response.data;
        });
    },
    getBmiCategoryColor() {
      if (this.user?.bmi?.category) {
        return Utils.getBmiCategoryColor(this.user.bmi.category);
      }
      return "";
    },
    downloadProfile() {
      console.log('downloadProfile started');
      this.$store.dispatch("download/downloadUserProfile", {
          udid: this.udid,
          dt_from: dayjs(this.selectedDate)
            .startOf("day")
            .format(Constants.BUCKET_FORMAT),
          dt_to: dayjs(this.selectedDate)
            .startOf("day")
            .add(1, "day")
            .format(Constants.BUCKET_FORMAT),
        })
        .then((response) => {
          console.log('profile downloaded successfully', response)
          //const blob = new Blob([response.data], {type: 'blob'})
          // res.setHeader('Content-Type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
          // res.setHeader('Content-Disposition', 'attachment; filename=export.xlsx');
          
          // const link = document.createElement('a')
          // link.href = window.URL.createObjectURL(blob, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          // link.download = 'user_profile.csv'
          // link.click()
          // URL.revokeObjectURL(link.href)

          const url = window.URL.createObjectURL(new Blob([response.data]), {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}); //specify CT
          const link = document.createElement('a'); // attach link to DOM
          link.href = url;
          link.setAttribute('download', 'File.xlsx');
          document.body.appendChild(link);
          link.click(); // Auto dl the file
          link.remove(); // Remove the link
        });
    },
    downloadCsvProfile() {
      //TODO 
      console.log('downloadCsvProfile');
      const userId = 1; // Replace with dynamic user id if needed

    fetch('http://localhost:3000/download-csv', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId }),
    })
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `user_${userId}_sleep.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(err => {
        console.error('CSV Download Failed', err);
      });
    },
    getUserWellnessData(udid, sectionId) {
      this.$store.dispatch("data/userWellnessDetails", {
          udid: udid,
          selected_date: this.formatDate(this.selectedDate),
          section_id: !sectionId ? -1 : sectionId
        })
        .then((response) => {
          this.wellnessData = null;
          //console.log('wellness response: '+JSON.stringify(response))
          if(response && response.data && response.data.length > 0) {
            this.wellnessData = response.data;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .no-stress-found-container {
    background-color: rgb(40, 51, 53);
    border-radius: 0.5rem;
    padding-bottom: 0.5rem;
    // min-height: 23.5rem;
  }
</style>
